import { Col, Row } from 'react-bootstrap';
import { CompanyContributions } from './contributionsCards/company-contributions';
import { ContributionsAndLimits } from './contributionsCards/contributions-and-limits';
import { CurrentElections } from './contributionsCards/current-elections';

export const Contributions = () => {
  return (
    <>
      <Row className="justify-content-center d-flex mt-9">
        <Col className={'col-lg-4 col-12 mb-lg-0 mb-10'}>
          <CurrentElections />
        </Col>
        <Col className={'col-lg-4 col-12 mb-lg-0 mb-10'}>
          <ContributionsAndLimits />
        </Col>
        <Col className={'col-lg-4 col-12 mb-lg-0 '}>
          <CompanyContributions />
        </Col>
      </Row>
    </>
  );
};
